import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import renderSection2 from './section2';
import renderSection3 from './section3';
import renderSection4 from './section4';
import renderSection8 from '../Projection/section8';

import styles from './index.module.scss';

function Consulting(props) {
    document.title = "Консультирование";

    return (
    <main className={cn(styles.main, props.className, 'consulting')} style={{overflow:"hidden"}}>
      <img className={styles.cover} src={'/assets/c2aa1a88a438bab2075f28e41f110c08.png'} alt="alt text" />

      <div className={styles.flex_col}>
          {renderSection2(props)}
          {renderSection3(props)}
          {renderSection4(props)}
          {renderSection8(props)}
      </div>
    </main>
  );
}

Consulting.propTypes = {
  className: PropTypes.string
};

export default Consulting;
